<template>
    <div>
        <div class="row justify-content-md-center">
            <div class="col-md-6">
                <div class="mt-4 mb-2">
                    <div class="row">
                        <div 
                        v-for="(item, index) in colores"
                        :key="index"
                        class="col-md-3 col-sm-12">
                            <b-button
                                id="button-models"
                                @click="set_color(item)"
                                block
                                class="text-left"
                            >
                                <i class="fa fa-circle mr-1" 
                                :id="item.value"></i>
                                {{item.label}}
                            </b-button>
                        </div>
                    </div>
                    <b-button 
                    @click="back()"
                    variant="danger" class="button red mt-4" block>
                        <span>Volver</span>
                </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
    computed: {
        ...mapFields("vender", [
            'selection_data.color',
            'asistente_step',
            'titulo_span',
            'selection_data.version_id',
            'selection_data.version_name'
        ]),
    },
    data() {
        return {
            colores: [
                {
                    label: 'Amarillo',
                    value: 'yellow'
                },
                {
                    label: 'Azul',
                    value: 'blue'
                },
                {
                    label: 'Blanco',
                    value: 'white'
                },
                {
                    label: 'Beige',
                    value: 'beige'
                },
                {
                    label: 'Cafe',
                    value: 'brown'
                },
                {
                    label: 'Dorado',
                    value: 'golden'
                },
                {
                    label: 'Gris',
                    value: 'gray'
                },
                {
                    label: 'Morado',
                    value: 'purple'
                },
                {
                    label: 'Negro',
                    value: 'black'
                },
                {
                    label: 'Plateado',
                    value: 'silver'
                },
                {
                    label: 'Rojo',
                    value: 'red'
                },
                {
                    label: 'Verde',
                    value: 'green'
                },
                {
                    label: 'Otro',
                    value: 'other'
                }
            ]
        }
    },
    methods: {
        set_color(item) {
            this.color = item.label;
            this.asistente_step = 'kilometraje';
            this.titulo_span = 'Ingrese kilometraje...'
            window.history.replaceState(null, null, '?step=6');
        },
        back(){
            this.version_id = "";
            this.version_name = "";
            this.asistente_step = 'version';
            this.titulo_span = 'Seleccione version...'
        }
    },
};
</script>

<style lang="scss">
i#yellow {
    color: #ffec33;
}
i#blue {
    color: #2c1ef3a2;
}
i#beige {
    color: #fad7a0;
}
i#white {
    color: #ffffff;
}
i#brown {
    color: #5c4505;
}
i#golden {
    color: #d4ac0d;
}
i#gray {
    color: #566573;
}
i#purple {
    color: #8f0583;
}
i#black {
    color: #000000;
}
i#silver {
    color: #bdc3c7;
}
i#red {
    color: #ec1212;
}
i#green {
    color: #1f9432;
}
i#other {
    color: #ebeff3;
}
</style>
